/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Block3D = {
    block_type: Block3D.block_type;
    generation_ids: Array<string>;
};

export namespace Block3D {

    export enum block_type {
        _3D = '3d',
    }


}

